export default __webpack_public_path__ + "static/media/video-welcome-founders-club.ea46b1ef.jpg";